import { useMutation } from "@apollo/client";
import moment from "moment";
import { GoalArtifactSidebarFragmentFragment } from "types/graphql-schema";

import getArtifactActivitiesQuery from "@apps/artifact-sidebar/graphql/get-artifact-activities-query";
import { buttonTheme } from "@components/button/button";
import InputDatePicker from "@components/input/input-datepicker";

import updateArtifactMutation from "../graphql/update-artifact-mutation";

const GoalStartDate = ({
  artifact,
}: {
  artifact: Pick<
    GoalArtifactSidebarFragmentFragment,
    "id" | "startDate" | "dueDate" | "canUpdate"
  >;
}) => {
  const [updateArtifact] = useMutation(updateArtifactMutation);

  const handleSetStartDate = (date: Date | null) => {
    if (date === null) return;
    const startDate = date ? moment(date).format("YYYY-MM-DD") : null;
    updateArtifact({
      variables: {
        artifactId: artifact.id,
        additionalFields: { startDate },
      },
      optimisticResponse: {
        createOrUpdateArtifact: {
          artifact: {
            ...artifact,
            startDate,
          },
          __typename: "CreateOrUpdateArtifactMutation",
        },
      },
      refetchQueries: [getArtifactActivitiesQuery],
    });
  };

  return (
    <InputDatePicker
      date={artifact.startDate}
      onChangeDate={handleSetStartDate}
      isClearable={false}
      maxDate={moment(artifact.dueDate).toDate()}
      disabled={!artifact.canUpdate.permission}
      placeholderText="Start date"
      buttonProps={{ theme: buttonTheme.text }}
    />
  );
};

export default GoalStartDate;
